import { render, staticRenderFns } from "./CustomerReturnFormItems.vue?vue&type=template&id=12bae337&scoped=true"
import script from "./CustomerReturnFormItems.vue?vue&type=script&lang=js"
export * from "./CustomerReturnFormItems.vue?vue&type=script&lang=js"
import style0 from "./CustomerReturnFormItems.vue?vue&type=style&index=0&id=12bae337&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12bae337",
  null
  
)

export default component.exports